export const newsList = [
  {
    id: "news-1",
    type: "news",
    title: "年度盛典红毯直击：新生代演员集体亮相造型引发热议",
    excerpt:
      "一年一度的娱乐盛典如期而至，多位新生代演员以反差感造型登场，红毯现场星光熠熠，社交媒体话题量在十分钟内突破亿级。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20event%20stage%20with%20warm%20golden%20spotlights%20and%20soft%20bokeh%20background%2C%20glamorous%20awards%20ceremony%20atmosphere%2C%20editorial%20photography%2C%20rich%20orange%20and%20cream%20tones%2C%20clean%20composition&width=800&height=600&seq=news-cover-01&orientation=landscape",
    category: "明星",
    tags: ["盛典", "红毯", "新生代"],
    author: "娱乐观察员",
    source: "我爱搞娱乐",
    publishedAt: "2026-10-13",
    views: 128400,
    content: [
      "年度娱乐盛典于昨晚在城市文化中心落幕，超过两百位艺人出席。红毯环节从傍晚六点持续到八点，现场粉丝热情高涨。",
      "本届盛典最大的看点来自新生代演员的集体亮相。有人选择简洁的缎面礼服，有人则以大胆的色彩碰撞抢占镜头，反差感十足的造型迅速登上热搜。",
      "主办方透露，今年红毯的灯光与背景设计采用了暖金色调，让整体画面更有电影质感。造型团队表示，希望用更松弛的表达呈现年轻一代的自信。",
      "盛典完整奖项名单将在今晚公布，我爱搞将持续跟进报道。",
    ],
  },
  {
    id: "news-2",
    type: "news",
    title: "新片定档！悬疑电影《雾中回声》宣布国庆档上映",
    excerpt:
      "备受期待的悬疑电影《雾中回声》正式官宣定档，导演携主演阵容亮相发布会，现场公开首支预告片，氛围感十足。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20misty%20mountain%20town%20at%20dusk%20with%20soft%20fog%20and%20warm%20lantern%20lights%2C%20moody%20mystery%20film%20atmosphere%2C%20editorial%20photography%2C%20muted%20amber%20and%20slate%20tones%2C%20clean%20composition&width=800&height=600&seq=news-cover-02&orientation=landscape",
    category: "电影",
    tags: ["定档", "悬疑", "预告片"],
    author: "影讯速递",
    source: "我爱搞影视",
    publishedAt: "2026-10-12",
    views: 96320,
    content: [
      "悬疑电影《雾中回声》正式宣布定档，将于国庆档与观众见面。片方在发布会上公布了首支预告片与主创阵容。",
      "影片讲述一名声音采集师在山城小镇意外卷入一场旧案，随着录音带中的线索逐渐清晰，真相却越发扑朔迷离。",
      "导演在现场表示，影片最大的特色是声音叙事的运用，团队专门采集了上百种环境音，力求让观众在影院中身临其境。",
      "影片预售通道即将开启，具体场次信息可关注后续报道。",
    ],
  },
  {
    id: "news-3",
    type: "news",
    title: "华语流行新专辑上线首日播放量破纪录，歌迷直呼上瘾",
    excerpt:
      "某人气歌手的新专辑在零点准时上线，主打歌首日播放量刷新平台纪录，多个音乐榜单同时登顶。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20recording%20studio%20with%20warm%20amber%20lighting%20and%20vinyl%20records%20on%20shelf%2C%20cozy%20music%20production%20space%2C%20editorial%20photography%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20composition&width=800&height=600&seq=news-cover-03&orientation=landscape",
    category: "音乐",
    tags: ["新专辑", "榜单", "流行"],
    author: "音乐前线",
    source: "我爱搞音乐",
    publishedAt: "2026-10-11",
    views: 87450,
    content: [
      "零点刚过，这张备受瞩目的华语流行新专辑正式上线。主打歌在上线三小时内便冲上多个音乐平台的实时榜首。",
      "专辑共收录十首作品，风格横跨流行、民谣与轻电子。歌迷在社交平台留言称，副歌的旋律一听就上瘾，循环播放停不下来。",
      "制作团队介绍，专辑历时一年半打磨，其中两首歌曲在海外完成混音，希望呈现出更通透的听感。",
      "目前实体唱片与数字专辑均已开放购买，巡演计划也在筹备之中。",
    ],
  },
  {
    id: "news-4",
    type: "news",
    title: "综艺《周末去哪儿》口碑逆袭，真实感成为最大亮点",
    excerpt:
      "一档旅行类综艺在播出三期后口碑持续走高，节目放弃剧本设定，用纪录片式的拍摄记录嘉宾的真实反应，被观众称为下饭神综。",
    cover:
      "https://readdy.ai/api/search-image?query=sunny%20weekend%20countryside%20picnic%20with%20warm%20afternoon%20light%20and%20soft%20greenery%2C%20relaxed%20travel%20variety%20show%20atmosphere%2C%20editorial%20photography%2C%20warm%20orange%20and%20sage%20tones%2C%20clean%20composition&width=800&height=600&seq=news-cover-04&orientation=landscape",
    category: "综艺",
    tags: ["综艺", "口碑", "旅行"],
    author: "综艺观察",
    source: "我爱搞综艺",
    publishedAt: "2026-10-10",
    views: 74210,
    content: [
      "旅行综艺《周末去哪儿》在播出第三期后，评分从开播时的中游水平一路攀升，成为近期讨论度最高的节目之一。",
      "节目最大的不同在于放弃剧本，嘉宾的行程由抽签决定，镜头更多停留在真实的生活细节上：迷路的慌张、临时起意的野餐、意外的雨天。",
      "不少观众表示，这种不刻意制造冲突的表达反而更治愈，适合周末放松时观看。",
      "节目组透露，后续几期将前往更偏远的小镇，继续记录真实的旅途故事。",
    ],
  },
  {
    id: "news-5",
    type: "news",
    title: "经典剧集宣布翻拍，原班幕后团队回归引发期待",
    excerpt:
      "时隔多年，一部陪伴一代人成长的经典剧集宣布启动翻拍，原班幕后主创确认回归，官方同步放出概念海报。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20film%20set%20with%20warm%20amber%20spotlights%20and%20old%20camera%20equipment%2C%20nostalgic%20cinema%20production%20atmosphere%2C%20editorial%20photography%2C%20warm%20sepia%20and%20cream%20tones%2C%20clean%20composition&width=800&height=600&seq=news-cover-05&orientation=landscape",
    category: "剧集",
    tags: ["翻拍", "经典", "剧集"],
    author: "剧集雷达",
    source: "我爱搞剧集",
    publishedAt: "2026-10-09",
    views: 68930,
    content: [
      "一部陪伴一代观众的经典剧集正式宣布翻拍。片方公布的概念海报以暖色调为主，唤起不少人的回忆。",
      "令人惊喜的是，原班的编剧与美术指导确认回归，他们表示会在尊重原作精神的前提下，加入更符合当下审美的表达。",
      "选角工作正在进行，片方强调会以角色适配度为第一标准，不盲目追逐流量。",
      "该剧预计明年开机，更多消息请关注我爱搞的后续报道。",
    ],
  },
  {
    id: "news-6",
    type: "news",
    title: "舞台剧跨界合作官宣，多位实力派演员首次同台",
    excerpt:
      "一台融合话剧与现场乐队的跨界舞台剧正式官宣，多位实力派演员将首次同台，票房预售开启即秒空。",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20theater%20stage%20with%20warm%20amber%20spotlights%20and%20deep%20red%20curtains%2C%20live%20performance%20atmosphere%2C%20editorial%20photography%2C%20rich%20orange%20and%20gold%20tones%2C%20clean%20composition&width=800&height=600&seq=news-cover-06&orientation=landscape",
    category: "演出",
    tags: ["舞台剧", "跨界", "预售"],
    author: "演出指南",
    source: "我爱搞演出",
    publishedAt: "2026-10-08",
    views: 52310,
    content: [
      "一台融合话剧表演与现场乐队演奏的跨界舞台剧正式官宣，首轮演出将在下月开幕。",
      "据介绍，该剧把乐队安排在舞台之上，演员的表演会随着现场音乐即兴变化，每一场都独一无二。",
      "多位实力派演员将在本剧中首次同台，片方表示已为演员预留充足的排练时间，力求呈现最好的舞台效果。",
      "预售通道开启后短时间内售罄，第二轮场次信息即将公布。",
    ],
  },
  {
    id: "news-7",
    type: "news",
    title: "短剧市场持续升温，精品化路线成为行业新趋势",
    excerpt:
      "过去一年短剧市场规模快速增长，越来越多制作团队开始走精品化路线，在剧本、表演与画面上投入更多资源。",
    cover:
      "https://readdy.ai/api/search-image?query=compact%20film%20production%20studio%20with%20warm%20amber%20lighting%20and%20camera%20rig%2C%20minimal%20modern%20shooting%20space%2C%20editorial%20photography%2C%20warm%20orange%20and%20neutral%20tones%2C%20clean%20composition&width=800&height=600&seq=news-cover-07&orientation=landscape",
    category: "行业",
    tags: ["短剧", "趋势", "精品化"],
    author: "行业观察",
    source: "我爱搞行业",
    publishedAt: "2026-10-07",
    views: 45120,
    content: [
      "短剧在过去一年里成为增长最快的娱乐内容形态之一，用户的观看时长显著提升。",
      "值得注意的是，市场正从早期的数量竞争转向质量竞争。多家制作团队表示，开始把更多预算投入到剧本打磨与表演训练上。",
      "业内人士分析，精品化的短剧更容易形成口碑传播，也更能吸引品牌方的长期合作。",
      "未来一年，短剧与长视频、直播的联动或将成为新的探索方向。",
    ],
  },
  {
    id: "news-8",
    type: "news",
    title: "音乐节门票开售三分钟售罄，主办方紧急加开场次",
    excerpt:
      "一场集结多组人气乐队的户外音乐节门票开售三分钟内被抢空，主办方随后宣布加开一场，回应歌迷热情。",
    cover:
      "https://readdy.ai/api/search-image?query=open%20air%20music%20festival%20stage%20at%20sunset%20with%20warm%20orange%20sky%20and%20crowd%20silhouettes%2C%20energetic%20live%20concert%20atmosphere%2C%20editorial%20photography%2C%20warm%20amber%20and%20coral%20tones%2C%20clean%20composition&width=800&height=600&seq=news-cover-08&orientation=landscape",
    category: "音乐",
    tags: ["音乐节", "售票", "现场"],
    author: "现场速递",
    source: "我爱搞音乐",
    publishedAt: "2026-10-06",
    views: 39880,
    content: [
      "这场户外音乐节官宣阵容后便备受关注，门票开售三分钟内全部售罄，不少歌迷在评论区直呼手速不够。",
      "主办方随后宣布加开一场，并承诺优化入场动线与现场补给，提升观众体验。",
      "据悉，音乐节将设置两个舞台，白天以民谣与独立乐队为主，夜晚则交给电子与摇滚阵容。",
      "加场门票将于本周五中午开售，请关注官方渠道以免错过。",
    ],
  },
];